export default __webpack_public_path__ + "static/media/player-list-play.42093c7e.svg";